import React, { Fragment } from 'react';
import classNames from 'classnames';
import { resolveId } from '@wix/communities-blog-client-common';

import PopoverRoot from '../../../common/components/popovers/popover-root';
import PostSearchListItem from '../post-search-list-item';
import styles from './search-results-list.scss';

type Post = React.ComponentProps<typeof PostSearchListItem>['post'];

type Props = {
  posts: Post[];
  query?: string;
  onPostLikeClick: React.ComponentProps<typeof PostSearchListItem>['onLikeClick'];
};

const renderItem = ({ post, query, onPostLikeClick }: Props & { post: Post }) => {
  const postId = resolveId(post);
  const componentProps = {
    post,
    onLikeClick: onPostLikeClick,
    query,
    postMetadataFontSize: 12,
    postDescriptionFontSize: 16,
    postTitleFontSize: 26,
  };

  return (
    <div
      className={classNames(styles.listItemMobile, 'search-results-list__list-item')}
      key={postId}
      id={postId}
    >
      <PostSearchListItem type="search" {...componentProps} postDetailsLineCount={3} />
      <PopoverRoot />
    </div>
  );
};

const SearchResultsMobileList = (props: Props) => (
  <Fragment>{props.posts.map((post) => renderItem({ ...props, post }))}</Fragment>
);

export default SearchResultsMobileList;
